<div class="container-error-404">
	<div class="box-container">
		<div class="box-header-container">
			<div class="box-header-title">
				<div class="box-header">
					<div class="text">
						{{ 'page404.title' | translate:ts.GetLang}}
					</div>
					<div class="subtitle">
						{{ 'page404.subtitle' | translate:ts.GetLang}}
					</div>
				</div>
				<div class="box-footer">
					{{ 'page404.paragraph' | translate:ts.GetLang}}
				</div>
			</div>

		</div>
		<div class="box-bottons">
			<app-button-warehouse buttonClass="btn-md-secondary" label="buttons.refresh" (click)="goBack()">
			</app-button-warehouse>
			<app-button-warehouse label="buttons.goToMainScreen" buttonClass="btn-md-primary" (click)="tryToLogin()">
			</app-button-warehouse>
		</div>
	</div>
</div>
